module.exports = __webpack_public_path__ + "img/maze_hexagonal_g.e6588a5c.svg";